import { createContext, useContext } from "react";
import { GetCustomerDashboardDto } from "services/Dtos/CustomerDtos";

export interface CompanyContextValue {
  companyId: number;
  company: GetCustomerDashboardDto | null;
}

export const CompanyContext = createContext<CompanyContextValue | undefined>(undefined);

export const useCompanyContext = (): CompanyContextValue => {
  const context = useContext(CompanyContext);
  if (!context) throw new Error("useCompanyContext must be used inside CompanyLayout");
  return context;
};

export const companyPath = (companyId: number | string, section = "overview") =>
  `/companies/${companyId}/${section}`;
